export function setupStatusMessageCloseButtons () {
  setTimeout(() => {
    const rootElements = document.querySelectorAll('.status-messages')
    // console.log({ rootElements })
    for (const rootElement of rootElements) {
      const messages = rootElement.querySelectorAll(':scope .status-messages__item')
      for (const message of messages) {
        const closeButton = message.querySelector(':scope .status-messages__close-button')
        closeButton.addEventListener('click', event => {
          if (message.classList.contains('status-messages__item--hidden') === false) {
            message.classList.add('status-messages__item--hidden')
          }
        })
      }
    }
  }, 10)
}

// Drupal.behaviors.lawfulStatusMessages = {
//     attach(context, settings) {
//         setupStatusMessageCloseButtons()
//     }
// }
// document.addEventListener('DOMContentLoaded', function () {
//   // console.log('DOMContentLoaded!!!')
//   setupStatusMessageCloseButtons()
// })
